<template>
<!-- 店铺钱包 -->
<section class="viewContainer">
  <div class="main_container">
    <div class="twoflex">
      <p>
        <b style="font-size: 20px;">钱包余额：
          <span style="color: #F56C6C;">
            {{accumulate.balance||accumulate.freezeamount?accumulate.balance+accumulate.freezeamount:0}}
          </span> 元
        </b>
        <span v-show="accumulate.freezeamount">（含冻结{{accumulate.freezeamount}}元）</span></p>
      <!-- <p style="color: #ccc;">温馨提示：账户余额等数据会根据实际交易情况实时产生变动。</p> -->
    </div>
    <div class="fourflex">
      <div>累计充值：<b>{{accumulate.rechargeamount?accumulate.rechargeamount:0}}</b> 元</div>
      <div>累计使用：<b>{{accumulate.usedamount?accumulate.usedamount:0}}</b> 元</div>
      <div>累计提现：<b>{{accumulate.withdrawamount?accumulate.withdrawamount:0}}</b> 元</div>
      <div :class=" accumulate.waitamount? '' : 'divhide'">
        待入账金额：<b>{{accumulate.waitamount}}</b> 元</div>
      <div :class=" accumulate.recordedprice ? '' : 'divhide'">
        提现待打款：<b style="color: #409EFF;">{{accumulate.recordedprice}}</b> 元</div>
      <div v-show="iscityadmin==0">
        <el-button type="primary" @click="handlecztx(1)">充值</el-button>
        <el-button type="danger" @click="handlecztx(2)">提现</el-button>
      </div>
    </div>
  </div>
  <div class="main_container">
    <!-- <p style="margin-left: 15px;"><b>{{threetitle}}列表</b></p> -->
    <el-radio-group v-model="zdmxczjltxjl" @change="handleClickthree" style="margin: 10px 0 10px 10px;">
      <el-radio-button :label="0">账单明细</el-radio-button>
      <el-radio-button :label="1">充值记录</el-radio-button>
      <el-radio-button :label="2">提现记录</el-radio-button>
      <el-radio-button :label="6">冻结记录</el-radio-button>
    </el-radio-group>
    <div class="table_container">
      <!--  @selection-change="handleSelectionChange" -->
      <el-table :data="threelist" stripe border>
        <!-- <el-table-column type="selection" align="center"/> -->
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column prop="tradecode" label="交易流水号" align="center"/>
        <el-table-column prop="paytime" label="交易时间" align="center"/>
        <el-table-column prop="tradetypename" label="交易类型" align="center"/>
        <el-table-column prop="trademodename" label="交易对象" align="center"/>
        <el-table-column label="业务描述" align="center">
          <template scope="scope"><span class="spanList">{{ scope.row.remark }}</span></template>
        </el-table-column>
        <el-table-column label="金额（元）" align="center">
          <template scope="scope"><span v-show="scope.row.tradetype==2">-</span>{{scope.row.price}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="200" align="center">
          <template scope="scope">
            <span @click="chakancontent(scope.row)" class="handle"> <i class="el-icon-view"></i> 查看 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>

  <!-- 充值&提现-弹框 -->
  <el-dialog :title="cztxtitle" :visible.sync="dialogcztx" :center="true" width="35%" append-to-body>
    <el-form style="padding-bottom: 20px;">
      <template v-if="cztxtitle=='账户充值'">
        <el-form-item label="账户充值：" :style="sjdzje?'margin-bottom: 0;':''">
          <el-input v-model="zhcz" placeholder="请输入要充值的金额" maxlength="8" style="width:70%;"
          onkeyup="this.value=this.value.replace(/\D|^0/g,'')">
          <i slot="prefix" style="margin-left: 10px;">¥</i>
          </el-input>
          <br>
          <span style="color: #bbb;margin-left: 80px;" v-show="sjdzje">实际到账金额: {{sjdzje.toFixed(2)}}</span>
        </el-form-item>
        <el-form-item label="通知手机号：">
          <el-input v-model="noticePhone" placeholder="请输入手机号" style="width:70%;" maxlength="11"
          onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')"/>
        </el-form-item>
        <ul style="line-height: 25px;color: #bbb;">
          <li>温馨提示：</li>
          <li>1.当前操作仅支持微信扫码支付；</li>
          <li>2.实际到账金额=充值金额-充值金额*6‰，其中6‰为微信收取的手续费；</li>
          <li>3.通知手机号是为了金额到账后接收短信提醒；</li>
          <li>4.充值金额将在3-7个工作日入账，充值金额一年内允许提现，提现失效的余额在系统中可以继续使用。</li>
        </ul>
      </template>
      <template v-else>
        <!-- <el-form-item label="提现账号：" :style="unregistered?'margin-bottom: 0;':''">
          <el-input v-model="tixianzh" placeholder="请输入收款人手机号（手机号已注册'甄惠装'小程序'）" maxlength="11"
          @input="handletx" style="width:70%">
          <i slot="suffix" class="el-input__icon el-icon-success" style="color: #5cbb7a;" v-show="registered"/>
          <i slot="suffix" class="el-input__icon el-icon-error" style="color: #F56C6C;" v-show="unregistered"/>
          </el-input>
          <div style="color: #F56C6C;margin-left: 80px;" v-show="unregistered">手机号码未注册“甄惠装”小程序</div>
        </el-form-item>
        <el-form-item label="小程序码：" v-show="registered==false">
          <img src="../../assets/img/xcxm.jpg" style="width: 100px;"/>
        </el-form-item> -->
        <el-form-item label="提现金额：">
          <el-input v-model="zhtx" placeholder="请输入要提现的金额" style="width:70%;"
          oninput="value=value.replace(/[^\d^\.]/g,'')"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
          <!-- onkeyup="this.value=this.value.replace(/\D|^0/g,'')" -->
          <i slot="prefix" style="margin-left: 10px;">¥</i>
          </el-input>
          <br>
          <span style="color: #bbb;margin-left: 80px;">可提现金额: {{accumulate.can_withdraw_price}}</span>
        </el-form-item>
        <ul style="line-height: 25px;color: #bbb;">
          <li>温馨提示：</li>
          <li>1.提现成功后会发送短信通知；</li>
          <li>2.可提现金额=系统将在提现后3-7个工作日内进行打款，节假日顺延</li>
          <li>3.可提现金额=一年内充值且未消耗的金额总和；</li>
          <li>3.提现时系统会根据充值顺序依次原路返还，短信通知人为充值时输入的手机号。</li>
        </ul>
      </template>
    </el-form>
    <div style="text-align:center">
      <el-button @click="dialogcztx = false">取消</el-button>
      <el-button type="danger" @click="fixFh(1)" v-if="cztxtitle=='账户充值'">充值</el-button>
      <el-button type="danger" @click="fixFh(2)" v-else>确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="detailsDialog">
    <template v-slot:title>
      <span style="font-size: 18px;font-weight: bolder;color: #333;">交易详情</span>
    </template>
    <div style="width: 90%; margin: 0 auto;border-bottom: 1px solid #eee;padding: 10px 0 20px 0;">
      <!-- <b>任务信息</b> -->
      <p><span>创建时间：</span> <span>{{formDetails.paytime}}</span></p>
      <p><span>交易对象：</span> <span>{{formDetails.trademodename}}</span></p>
      <p><span v-if="this.tradetype==1">交易方式：</span> <span v-else>支付方式：</span> <span>{{formDetails.paymodename}}</span></p>
      <p v-show="formDetails.isrefund==1"><span>退款方式：</span> <span>{{formDetails.paymodename}}</span></p>
      <p><span>交易金额：</span> <span>{{formDetails.price}} 元</span></p>
      <p><span>交易状态：</span>
        <template v-if="formDetails.refundtradecode!=''">
          <span v-show="formDetails.isrefund==1">退款成功</span>
          <span v-show="formDetails.isrefund==0">全额退款</span>
        </template>
        <template v-else>
          <span>交易成功</span>
        </template>
      </p>
      <p><span>交易明细：</span> <span>{{formDetails.remark}}</span></p>
      <p><span>交易单号：</span> <span>{{formDetails.tradecode}}</span></p>
      <p v-show="formDetails.refundtradecode"><span>关联记录：</span>
        <span style="color: #409EFF; cursor: pointer;" @click="gljl(formDetails.refundtradecode)">{{formDetails.refundtradecode}}</span>
      </p>
    </div>
  </el-drawer>
  <!-- 微信扫码支付 -->
  <el-dialog title="微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf">
    <div style="width: 90%; margin: 0 auto; text-align: center;">
      <div><b style="font-size: 26px;">{{wxsmzfJine}} 元</b></div>
      <!-- <div style="color: #ccc;">（含6‰手续费）</div> -->
      <img :src="wxSmzfImg" style="width: 200px;"/>
    </div>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%" center>
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, postPlaceOrderNative, } from '../../api/newOss';
import { vmaccountgetinfo, vmaccountgetlist, vmaccountgetdetail, vmaccountgetbalance, vmaccountisrecharge,
  vmaccountwithdraw, getpayee, setpayee } from "../../api/shopWindow";
export default {
  name: 'vmacount', // 店铺钱包
  mixins: [alertTrends],
  data() {
    return {
      goodIdarr:[], // 复选框 集合
      
      dialogVisibleadd: false,
      bbid:'',  //店铺id
      options1: [],

      timer: null, // 轮询
      lxTime: 0, // 初始开始请求时间
      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      monitorid: '', // 充值单ID
      
      accumulate: {}, // 累计
      zdmxczjltxjl: 0, // 账单明细&充值记录&提现记录
      threetitle: '账单明细',
      threelist: [],
      pageIndex: 1, // 当前页
      total: 0, // 总条数
      listid: "", // 选中行id

      dialogcztx: false, // 账户充值 & 余额提现
      cztxtitle: '账户充值', // 标题
      zhcz: '', // 账户充值
      noticePhone: '', // 通知手机号
      tixianzh: '', // 提现账号
      registered: false, // 已注册
      unregistered: false, // 未注册
      zhtx: '', // 余额提现
      residuebalance: '', // 当前余额
      limit: '', // 当日最大可提现金额 单位：元

      detailsDialog: false, // 抽屉详情
      tradetype: '',
      formDetails: {}, // 任务信息

      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是
	  
	  configData: null, // 存储从后端获取的微信配置信息
      
    };
  },
  computed: {
    sjdzje() {
      let thiszhcz = this.zhcz * 0.994;
      return (Math.floor(thiszhcz * 100) / 100);
    },
  },
  methods: {
    // 账单明细&充值记录&提现记录 - 切换tab
    handleClickthree(val){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.getthree();
      this.pageIndex = 1;
      this.init();
      if(val==0){
        this.threetitle='账单明细';
      }else if(val==1){
        this.threetitle='充值记录';
      }else{
        this.threetitle='提现记录';
      }
    },
    getthree(){
      vmaccountgetinfo('', 3, this.bbid).then(data => {
        this.accumulate = data.resultObj; // 累计
      });
    },
    // 账单明细&充值记录&提现记录
    init() {
      let obj = {
        mode: this.zdmxczjltxjl==6?'':this.zdmxczjltxjl, // 交易方式0=全部 1=账户充值 2=余额提现 3=客户资源
        type: this.zdmxczjltxjl==6?4:'',
        pageindex: this.pageIndex,
        pagesize: 10
      };
      vmaccountgetlist(obj, 3, this.bbid).then(data => {
        if(data.resultCode == 1){
          this.threelist = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        }else{
          this.threelist = [];
          this.total = 0;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 查看
    chakancontent(row){
      this.tradetype=row.tradetype; // 交易类型
      this.detailsDialog=true;
      vmaccountgetdetail('', 3, this.bbid, row.tradecode).then(data => {
        this.formDetails = data.resultObj; // 交易详情
      });
    },
    // 提现账号
    handletx(){
      if(this.tixianzh.length==11){
        this.setpayee(); // 设置
      }else{
        this.registered=false;
        this.unregistered=false;
      }
    },
    // 获取
    getpayee(){
      getpayee('',this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.tixianzh = data.resultObj; // 店铺收款人手机号
          this.registered=true;
          this.unregistered=false;
        }else{
          this.registered=false;
          this.unregistered=true;
        }
      });
    },
    // 设置
    setpayee(){
      let obj = {
        phone: this.tixianzh,
      }
      setpayee(obj,this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.registered=true;
          this.unregistered=false;
        }else{
          this.registered=false;
          this.unregistered=true;
        }
      });
    },
    // 充值提现
    handlecztx(type){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.dialogcztx=true;
      if(type==1){
        this.cztxtitle='账户充值';
        this.zhcz='';
        this.noticePhone='';
      }else{
        this.cztxtitle='余额提现';
        this.tixianzh='';
        this.registered=false;
        this.unregistered=false;
        this.zhtx='';
        this.getpayee(); // 先获取手机号
      }
    },
    // 充值&提现 - 确定操作按钮
    fixFh(type){
      if(type==1){ // 走充值逻辑
        if (this.zhcz == '') {
          this.showAlert('账户充值不能为空');
          return;
        }
        if (this.noticePhone == '') {
          this.showAlert('通知手机号不能为空');
          return;
        }
        let obj = {
          attach: 'vmrecharge,' + 3 +','+ this.bbid +','+ this.zhcz +','+ 2 +','+ localStorage.Id +',' + this.noticePhone
        };
        postPlaceOrderNative(obj).then(data => {
          if (data.resultCode == 1) {
            this.dialogcztx=false;
            this.wxsmzfVisible = true;
            this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
            this.monitorid = data.resultObj.monitorid; // 充值单ID
            this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
            
            this.lxTime = new Date().getTime() // 获取触发轮询时的时间
            this.inquireData() // 调用轮询接口,开始进行轮询
            
          } else if(data.resultCode == 4) {
            this.showAlert('支付成功', 'success');
            this.getthree();
            this.pageIndex = 1;
            this.init();
          }
        });
      }else{ // 走提现逻辑
        // if (this.tixianzh=='') {
        //   this.showAlert('请输入提现账号');
        //   return;
        // }
        // if (this.tixianzh.length!=11) {
        //   this.showAlert('请输入完整手机号');
        //   return;
        // }
        // if (this.unregistered || !this.registered) {
        //   this.showAlert('手机号码未注册');
        //   return;
        // }
        if (this.zhtx == '') {
          this.showAlert('提现金额不能为空');
          return;
        }
        if (this.zhtx == '') {
          this.showAlert('提现金额不能大于可提现金额');
          return;
        }
        vmaccountgetbalance('', 3, this.bbid).then(data => {
          this.residuebalance = data.resultObj.balance; // 当前余额 单位：元
          this.limit = data.resultObj.limit; // 当日最大可提现金额 单位：元
          if(this.zhtx>this.residuebalance){
            this.showAlert('账户余额不足');
            return false;
          }else{
            if(this.zhtx>this.limit){
              // this.showAlert('今日剩余可提现额度为'+this.limit+'元，提现金额不能超过可提现额度。');
              this.showAlert('提现额度不足，请降低提现金额或明天再试');
              return false;
            }else{
              let obj = {
                price: this.zhtx, // 提现金额 单位：元 （最低0.3元 最高2000元）
                operatorid: localStorage.Id, // 当前登陆人id
				phone: this.tixianzh,
              };
              vmaccountwithdraw(obj, 3, this.bbid).then(data => {
                if (data.resultCode == 1) {
                  this.showAlert('操作成功', 'success');
                  this.dialogcztx=false;
                  this.getthree();
                  this.pageIndex = 1;
                  this.init();
                }else{
                  this.showAlert(data.resultMsg);
                  return false;
                }
              });
            }
          }
        });
      }
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData () {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.lxTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      vmaccountisrecharge('',this.monitorid).then(res => {
        if (res && res.resultCode === 1) {
          // resultObj 充值单状态 0=未支付 1=已支付
          if(res.resultObj===1) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.dialogcztx=false;
            this.showAlert('支付成功', 'success');
            this.getthree();
            this.pageIndex = 1;
            this.init();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 批量删除
    endDeletegood(){
      if(this.goodIdarr.length == 0){
        this.showAlert('请选择需要删除的数据');
        return false
      }
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = {
            userId: localStorage.Id,
            contentIds: this.goodIdarr.join(",")
          }
          getBatchDeleteContent(obj).then(data=>{
            if(data.ResultCode == 1){
              this.showAlert('操作成功', 'success');
             if(this.goodIdarr.length == this.threelist.length){
               if(this.pageIndex>1){
                 this.pageIndex = this.pageIndex-1
               }else{
                 this.pageIndex = 1
               }
              }
              this.init()
            }
          })
        }
      })
    },
    // 复选框
    handleSelectionChange(val) {
      this.goodIdarr = [];
      val.forEach(element => {
        this.goodIdarr.push(element.Id);
      });
    },
    // 关联记录
    gljl(row){
      this.detailsDialog=true;
      vmaccountgetdetail('', 3, this.bbid, row).then(data => {
        this.formDetails = data.resultObj; // 交易详情
      });
    },
    // 商家联盟获取用户身份以及可查看的店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(this.bbid){
              this.gonext();
            }else{
              if(data.resultObj.length>1){
                // this.bbid = data.resultObj[0].id; // 店铺id
                // this.gonext();
                this.dialogVisibleadd = true;
                this.options1 = data.resultObj;
              } else { // 默认选中第一个店铺不显示弹框
                this.dialogVisibleadd = false;
                this.bbid = data.resultObj[0].id; // 店铺id
                this.gonext();
              }
            }
          }
        }
      })
    },
    gonext(){
      console.log(this.bbid)
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.getthree();
      this.pageIndex = 1;
      this.init();
      this.dialogVisibleadd = false;
    },
  },
  mounted() {
    this.bbid = this.$route.query.shopid; // 店铺id
    this.tankuang(); // 商家联盟获取用户身份以及可查看的店铺
	// this.loadWechatSDK(); // 加载微信 JS-SDK
  },
};
</script>

<style scoped>
.twoflex{
  display: flex;
  justify-content: space-between;
  margin: 0 15px 0 20px;
}
.fourflex{
  display: flex;
  justify-content: space-between;
  margin: 0 20px 10px 20px;
}
.fourflex div{
  font-size: 16px;
  margin-top: 10px;
}
/* 元素占位 */
.divhide{
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// vmacount.vue?c994d246